export default __webpack_public_path__ + "assets/images/631f0d4a657a8fd5c061d2203c737412.png";